/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mail-sender[_nghost-%COMP%]   .fa-dark[_ngcontent-%COMP%], .mail-sender   [_nghost-%COMP%]   .fa-dark[_ngcontent-%COMP%]{padding:40% 0;color:#000}.mail-sender[_nghost-%COMP%]   .btn-reply[_ngcontent-%COMP%], .mail-sender   [_nghost-%COMP%]   .btn-reply[_ngcontent-%COMP%]{font-size:180%}.btn-reply[_ngcontent-%COMP%]{font-size:22px}.fa-dark[_ngcontent-%COMP%]{position:relative;color:#666}.fa-dark[_ngcontent-%COMP%]:hover{color:#000;border:none}.fa-disabled[_ngcontent-%COMP%]{color:#cfcfcf}"];
export { styles as styles };
